import { ImportQueueIcon } from "../icons";
import Create from "./Create";
import Edit from "./Edit";
import List from "./List";

export default {
	options: {
		group: "automation",
		roles: ["admin", "user"],
	},
	icon: ImportQueueIcon,
	list: List,
	edit: Edit,
	create: Create,
};
